import PropTypes from "prop-types";
import React from "react";

const PossibleMatchingOffers = ({ offers, eventType, hrefFor, onAdd, onDismiss }) => {
  if (!offers || offers.length === 0) return null;

  const eventNoun = eventType === "Confirm" ? "confirm" : "hold";

  return (
    <div className="sl-offers-matching">
      <div className="sl-offers-matching-head">
        <div>
          <strong className="sl-offers-matching-title">Possible Matching Offer(s)</strong>
          <p className="sl-offers-matching-sub">
            {`We found these offers that don't have an associated event but may be applicable to this ${eventNoun}. Add it now to unlock even more capabilities.`}
          </p>
        </div>
        <a
          href="#"
          className="sl-offers-matching-dismiss"
          aria-label="Dismiss matching offers"
          onClick={(e) => {
            e.preventDefault();
            onDismiss();
          }}
        >
          <i className="fal fa-times"></i>
        </a>
      </div>
      {offers.map((offer) => (
        <div className="sl-offers-matching-row" key={`${offer.ui_version}-${offer.id}`}>
          <div>
            <p className="sl-offers-matching-name">
              <strong>
                {offer.artist_or_event_name}
                <a href={hrefFor(offer)} target="_blank" rel="noopener noreferrer" aria-label={`View offer for ${offer.artist_or_event_name}`}>
                  <i className="far fa-eye text-primary ml-1"></i>
                </a>
              </strong>
            </p>
            <p className="sl-offers-matching-meta">{offer.human_metadata}</p>
          </div>
          <a
            href="#"
            className="sl-offers-matching-add"
            onClick={(e) => {
              e.preventDefault();
              onAdd(offer);
            }}
          >
            <strong>Add Offer</strong>
          </a>
        </div>
      ))}
    </div>
  );
};

PossibleMatchingOffers.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    ui_version: PropTypes.number,
    artist_or_event_name: PropTypes.string,
    human_metadata: PropTypes.string,
  })),
  eventType: PropTypes.string,
  hrefFor: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default PossibleMatchingOffers;
